<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-if="
            params &&
            params.context &&
            params.context.parentComponent &&
            params.context.parentComponent.permissions &&
            params.context.parentComponent.permissions.change &&
            params.context.parentComponent.tab == 0
          "
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="editItem"
          class="mr-4 ml-1"
        >
          mdi-pencil
        </v-icon>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon color="primary" v-on="on" v-bind="attrs" @click="viewItem">
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    editItem() {
      this.params.context.parentComponent.editOrder(this.params.data.id);
    },
    viewItem() {
      this.params.context.parentComponent.viewDeliveryAdvice(
        this.params.data.id
      );
    },
  },
};
</script>

<style></style>
